import LTR from "@brand-icons/global/device-video/device-video-ltr.svg";

import { iconFactory } from "../iconFactory";

export const DeviceVideoIcon = iconFactory("DeviceVideoIcon", LTR);
